import { render, staticRenderFns } from "./Not_Found.vue?vue&type=template&id=08e6bfce&scoped=true&"
import script from "./Not_Found.vue?vue&type=script&lang=js&"
export * from "./Not_Found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e6bfce",
  null
  
)

export default component.exports